module.exports = __webpack_public_path__ + "static/media/funded.d7f02e41.jpg";